import { TextField } from "@mui/material";
import { useState } from "react";
import { CatalogService } from "@services/catalog/catalogService";
import { CatalogVertical } from "@models/catalog.model";
import { FormDialog } from "./FormDialog";

export function VerticalDialog({
  initial, onClose, onSaved,
}: {
  initial: CatalogVertical | null; // null = create
  onClose: () => void;
  onSaved: (saved: CatalogVertical) => void; // page switches to the saved vertical
}) {
  const svc = new CatalogService();
  const [code, setCode] = useState(initial?.code ?? "");
  const [name, setName] = useState(initial?.name ?? "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      const saved = initial
        ? await svc.updateVertical(initial.id, { code, name })
        : await svc.createVertical({ code, name });
      onSaved(saved);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Save failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <FormDialog
      open
      title={initial ? "Edit vertical" : "New vertical"}
      onClose={onClose}
      onSave={save}
      saving={saving}
      error={error}
      canSave={!!code.trim() && !!name.trim()}
    >
      <TextField label="Code" value={code} onChange={(e) => setCode(e.target.value)}
        helperText="Machine id referenced by data/config, e.g. retail" size="small" autoFocus />
      <TextField label="Name" value={name} onChange={(e) => setName(e.target.value)}
        helperText="Display label, e.g. Retail" size="small" />
    </FormDialog>
  );
}
